import React from "react";
import { AreaChart } from "react-chartkick";
import { toISODate } from "../helpers";

export const MonkeyPointsChart = ({ points }) => {
  // console.log({ points });
  const monkeyData = {};
  const managerData = {};
  points.forEach(({ id, manager, monkey }) => {
    monkeyData[id] = monkey;
    managerData[id] = manager * 100;
  });

  return (
    <div>
      <AreaChart
        data={monkeyData}
        xtitle="Date"
        ytitle="Tasks Completed"
        curve={true}
        download={"monkeywork"}
        title={"Tasks Checked Off"}
        colors={["#2ecc71"]}
        // max={100}
        min={0}
      />
      <AreaChart
        data={managerData}
        xtitle="Date"
        ytitle="% Tasks Completed"
        curve={true}
        download={"managerefficency"}
        title={"Manager Efficency"}
        colors={["#2ecc71"]}
        max={100}
        min={0}
      />
    </div>
  );
};

export default MonkeyPointsChart;



// WEBPACK FOOTER //
// ./src/charts/MonkeyPointsChart.js